/* eslint-disable react/react-in-jsx-scope */
import './style.css'
import credit from '../../img/КредитТБ.png'
import installment from '../../img/в-рассрочкуТБ.png'
import percentage from '../../img/Dolyame logo.png'

const CreditBank = () => {
  return (
    <>
      <div className="bank center">
        <h1 className="bank-slogan">
          УЧИСЬ СЕЙЧАС, <span className="yellow-span">ПЛАТИ ПОТОМ!</span>
        </h1>
        <div className="bank-box">
          <div className="credit">
            <img className="credit-img" src={credit} />
            <div className="credit-box">
              <p className="credit-txt">Подробная иформация по кредиту</p>
              <a
                className="credit-btn"
                href="https://acdn.tinkoff.ru/static/documents/docs-all-about-buying-on-credit.pdf"
              >
                подробнее
              </a>
            </div>
          </div>
          <div className="percentage-box">
            <div className="percentage">
              <p className="percentage-txt yellow-span">FREE SUN FILM SCHOOL</p>
              <p className="percentage-slash">|</p>
              <img className="percentage-img" src={percentage} />
            </div>
          </div>

          <div className="installment">
            <div className="installment-box">
              <p className="installment-txt">Подробная иформация по рассрочке</p>
              <a
                className="installment-btn"
                href="https://acdn.tinkoff.ru/static/documents/docs-all-about-installment-terms.pdf"
              >
                подробнее
              </a>
            </div>
            <img className="installment-img" src={installment} />
          </div>
        </div>
      </div>
      <div className="info center">
        <div className="info-box">
          <p className="info-txt">
            На основании п. 4 ст. 5 Федерального закона от 21.12.2013 N 353-ФЗ
            (ред. от 08.03.2022) «О потребительском кредите (займе)». Рассрочка
            — это форма кредита (займа) с оплатой товаров или услуг несколькими
            частями, при котором проценты по кредиту (займу) частично или
            полностью компенсируется продавцом. Пос-кредит (займ) — это форма
            кредита (займа), предоставленная непосредственно в точке продаж или
            на сайте интернет-магазина. Банк 1: полная стоимость
            потребительского кредита (займа) — от 0% до 60% годовых, процентная
            ставка от 0% до 100% годовых, Банк 2: полная стоимость
            потребительского кредита (займа) — от 0% до 60% годовых, процентная
            ставка от 0% до 100% годовых, и т.д . Минимальная сумма - 3000 р.,
            максимальная сумма — 500 000 рублей. Срок предоставления — от 3 до
            36 месяцев. Условия обслуживания будут определены по результатам
            рассмотрения заявки.{' '}
            <a
              className="info-text-ref"
              href="https://cdn.tbank.ru/static/documents/list-creditors-and-terms-lending-t-installments.pdf"
            >
              Подробные условия.
            </a>
          </p>
        </div>
      </div>
    </>
  )
}

export default CreditBank
